export default __webpack_public_path__ + "static/atul-fa94c42d509e90858f80975d53ab4f48.png";